const language = 'en'

export default language;
